export const equipmentTypesList = [
  'gateways',
  'routers',
  'motes',
  'nodes',
  'installationPoints',
  'tachometers',
];
